var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import PartiText from './PartiText';
import { color, fontFamily, fontWeight } from '../Styles/Base';
var RoundCornerButton = function (_a) {
    var disabled = _a.disabled, customStyle = _a.customStyle, customText = _a.customText, dark = _a.dark, onPress = _a.onPress, children = _a.children, testID = _a.testID;
    var combinedTextStyle = __assign(__assign(__assign({}, styles.text), { color: dark ? color.white : color.astronaut }), customText);
    return (React.createElement(TouchableOpacity, { disabled: disabled, style: [styles.container, { backgroundColor: dark ? color.astronaut : color.white }, customStyle], onPress: onPress, testID: testID },
        React.createElement(PartiText, { style: combinedTextStyle }, children)));
};
var styles = StyleSheet.create({
    container: {
        height: 60,
        width: '90%',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 65 / 2,
    },
    text: {
        fontSize: 18,
        fontFamily: fontFamily.title,
        fontWeight: fontWeight.bold,
        color: color.astronaut,
        textAlign: 'center',
    },
});
export default RoundCornerButton;
